import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useCustomizationOptions } from '../hooks/useCustomizationOptions';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedDescriptionAdditionalOptionsContent } from '../PdpSharedDescriptions/PdpSharedDescriptionAdditionalOptionsContent';
import { PdpSharedBorderContainer } from '../shared/PdpSharedBorderContainer/PdpSharedBorderContainer';
import Production from 'dibs-icons/exports/Production';

import dibsCss from 'dibs-css';
import cn from 'classnames';

// types
import { type PdpRespSidebarDetailsCustomization_item$key as Item } from './__generated__/PdpRespSidebarDetailsCustomization_item.graphql';
import { type PdpRespSidebarDetailsCustomization_user$key as User } from './__generated__/PdpRespSidebarDetailsCustomization_user.graphql';

const Customization = (
    <FormattedMessage
        id="PdpRespSidebarDetailsCustomization.customization.header"
        defaultMessage="This item is customizable"
    />
);

const userFragment = graphql`
    fragment PdpRespSidebarDetailsCustomization_user on User {
        ...PdpSharedDescriptionAdditionalOptionsContent_user
    }
`;

const itemFragment = graphql`
    fragment PdpRespSidebarDetailsCustomization_item on Item {
        isCustomizable
        isDyoCustomizable
        ...useCustomizationOptions_item
        ...PdpSharedDescriptionAdditionalOptionsContent_item
    }
`;
export const PdpRespSidebarDetailsCustomization: FC<{ item: Item; user: User | null }> = ({
    item: itemRef,
    user: userRef,
}) => {
    const user = useFragment(userFragment, userRef);
    const item = useFragment(itemFragment, itemRef);
    const { customizationOptions, isResizable } = useCustomizationOptions({ item });

    const { isCustomizable = null, isDyoCustomizable } = item || {};

    if (!(isCustomizable && !!customizationOptions) && !isDyoCustomizable && !isResizable) {
        return null;
    }

    return (
        // <PdpRespSidebarDetailsSection title={Customization} ga={{ trigger: 'customization' }}>
        <PdpSharedBorderContainer className={cn(dibsCss.mySmall, dibsCss.pSmaller)}>
            <div
                className={cn(
                    dibsCss.sassyFontBodySmallHeavy,
                    dibsCss.mbXxsmall,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.gapXsmall
                )}
            >
                <Production variation="20" />
                {Customization}
            </div>
            {/* @ts-expect-error */}
            <PdpSharedDescriptionAdditionalOptionsContent
                item={item}
                user={user}
                disableExpansion
                buttonType="link"
                buttonWrapperClassName={cn(dibsCss.mtSmaller, dibsCss.sassyFontBodySmall)}
                contentSize="small"
                buttonSize="small"
                isResizable={isResizable}
                isDyoCustomizable={isDyoCustomizable}
                customizationOptions={customizationOptions}
            />
        </PdpSharedBorderContainer>
    );
};
